import * as React from 'react';
export const websterbankSvg = React.forwardRef(function websterbankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#004EA9',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4a12 12 0 1 0 12 12A12.008 12.008 0 0 0 16 4Zm0 22.739a10.74 10.74 0 1 1 9.924-6.628A10.73 10.73 0 0 1 16 26.739Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm13.988 21.47-5.88-10.476h3.923l3.923 6.979-1.966 3.497Zm5.632 0-5.88-10.476h3.931l3.915 6.971-1.965 3.505Z',
      fill: '#FFB71B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25.5 10.994h-3.922l-1.957 3.482h3.93l1.95-3.482Z',
      fill: '#FFB71B',
    }),
  );
});
websterbankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var websterbank = {
  category: 'brand',
  colorable: false,
  name: 'websterbank',
  svg: websterbankSvg,
};
